import { SetupProfession as UseCaseReduxSetupProfession } from '~/domain/usecases/profession/redux';
import { ReduxSetupProfession } from '~/data/store/reducer/profession/usecases/ReduxSetupProfession';

/**
 * send request via REDUX.
 */
export const makeReduxSetupProfession = (): UseCaseReduxSetupProfession =>
  new ReduxSetupProfession();
